import { render, staticRenderFns } from "./GroupSearch.vue?vue&type=template&id=5b25ee6a&scoped=true&"
import script from "./GroupSearch.vue?vue&type=script&lang=js&"
export * from "./GroupSearch.vue?vue&type=script&lang=js&"
import style0 from "./GroupSearch.vue?vue&type=style&index=0&id=5b25ee6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b25ee6a",
  null
  
)

export default component.exports